import { VFC } from 'react';
import { DialogContent, Dialog, Button } from '@mui/material';
import logo from 'assets/images/engarde-logo.svg';

const AccountCreationSuccessModal: VFC<{
  onClose: () => void;
  onGoToLink: (link: string) => void;
}> = ({ onClose, onGoToLink }) => {
  const handleGoToLogin = () => {
    onGoToLink('/');
  };
  return (
    <Dialog open={true} onClose={onClose} maxWidth="sm" scroll="body">
      <DialogContent className="p-0 flex justify-center items-center flex-col min-w-[400px]">
        <img src={logo} className="my-12 h-14 w-14" alt="Engarde logo" />
        <h1 className="text-center text-xl tracking-widest uppercase max-w-[300px]">
          Password Reset Email Sent
        </h1>

        <div className="max-w-[320px]">
          <p className="my-6 text-center">Check your inbox for the password reset link.</p>
        </div>
        <Button
          onClick={handleGoToLogin}
          className="w-full bg-black text-white py-3 rounded-none hover:bg-slate-800">
          Continue
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default AccountCreationSuccessModal;
